import { Alert, Stack, Text } from '@mantine/core';
import type { PortalNotice } from '../../lib/api.customer';
import { NOTICE_TYPE_CONFIG } from '../../lib/noticeTypeConfig';

interface Props {
  notices: PortalNotice[];
}

export function NoticesBanner({ notices }: Props) {
  if (notices.length === 0) return null;

  return (
    <Stack gap="xs" mb="md">
      {notices.map((n) => {
        const cfg = NOTICE_TYPE_CONFIG[n.type];
        return (
          <Alert
            key={n.id}
            color={cfg.color}
            variant="light"
            icon={<cfg.Icon size={18} />}
            title={n.title}
          >
            {n.message}
            {n.validUntil && (
              <Text size="xs" c="dimmed" mt={4}>
                Voraussichtlich behoben bis:{' '}
                {new Date(n.validUntil).toLocaleString('de-DE', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                })}
              </Text>
            )}
          </Alert>
        );
      })}
    </Stack>
  );
}
